/* eslint-disable */
import { ItemOffer } from '../models/item.offer.model';

export const mockItemOfferData: ItemOffer = {
  itemOfferHash: 'DFE89F67-6F26-4A02-A7DC-70928C4BA862',
  itemGid: '3723859',
  offerReference: '004-000-001-940',
  periodOfCover: 12,
  fee: 69.48,
  paymentType: 'D',
  numberOfPayments: 12,
  firstPayment: 5.79,
  subsequentPayment: 5.79,
  itemUrn: 'DGN:8868502',
};
